export default function(value) {
  if (isNaN(value)) {
    return value;
  } else {
    return `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}
